import styled from 'styled-components';

export const ProjectsCounterContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: var(--spacing-component-xs);

  a {
    display: inline-flex;
    margin-right: var(--spacing-component);

    span {
      display: inline-block;
    }
  }
`;
